<div>
  <i class="xos-icon icon-success"></i>
  Service request <span>{{ message }}</span> for <span>{{ title }}</span> is pending confirmation!
</div>
<button (click)="close()">
  <i class="xos-icon icon-close-white"></i>
</button>
